/* eslint-disable no-console */
import React, { Suspense } from 'react'
import { Switch } from 'react-router-dom'

import PublicRoute from 'Components/route/publicRoute'
import Loading from 'Components/loading'

import BlankLayout from 'Layouts/blank'

import ForbiddenScreen from 'Modules/other/403'
import NotFound from 'Modules/other/notFound'
import RegisterRoutes from 'Modules/auth/register/routes'
import LogoutHiddenScreen from 'Modules/auth/logout/logout-hidden'
import ModalError from 'Components/modalError'
import CustomRoute from 'Components/route/customRoute'
import { useRoot, useAuth } from 'Hooks'
import Overlay from 'Components/form/overlay'
import { ROUTES } from './constant'
import PrivateRoute from '../Components/route/privateRoute'

export default function AppRoutes() {
  const { isShowOverlay } = useRoot()
  const { authenticated } = useAuth()
  return (
    <>
      <Suspense fallback={<Loading />}>
        <Switch>
          <CustomRoute exact path="/403" layout={BlankLayout} component={ForbiddenScreen} />
          <CustomRoute exact path="/not-found" layout={BlankLayout} component={NotFound} />
          <CustomRoute exact path="/logout-hidden" layout={BlankLayout} component={LogoutHiddenScreen} />
          {ROUTES.map((routeConfig, index) => {
            if (routeConfig.isCustom && !authenticated) {
              return (
                <CustomRoute key={index} exact path={routeConfig.path} component={routeConfig.component} layout={routeConfig.layout} />
              )
            }
            if (routeConfig.isAuth) {
              return (
                <PrivateRoute
                  key={index}
                  exact
                  {...routeConfig}
                />
              )
            }

            return (
              <PublicRoute
                key={index}
                exact
                {...routeConfig}
              />
            )
          })}
          <RegisterRoutes />
        </Switch>
        { isShowOverlay && <Overlay />}
        <ModalError />
      </Suspense>
    </>
  )
}
